import React from "react";
import { EnterpriseSelectionCard } from "components";

function Welcome() {
  return <EnterpriseSelectionCard url="welcome" />;
}

export default Welcome;
